import React from 'react';
import { Link } from 'react-router-dom';

export default function ReportingCard({ teamId }) {
  return <div className="team-card">
    <div className="card-header-with-icon"><span className="card-title">Reporting</span></div>
    <div className="card-body">
      <p>Explore ready-made dashboards, customise reports and combine insights from across your club’s modules.</p>
    </div>
    <div className="card-reporting-footer">
      <Link className="btn btn--secondary btn--xs card-reporting-action" aria-label="Open club reporting" to={`/teams/${teamId}/reporting`}>View reporting <span aria-hidden="true">→</span></Link>
    </div>
  </div>;
}
